








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Button extends Vue {
    @Prop({ default : true}) isPressable!: boolean;
    isPressed = false;

    setPressed(): void {
        if (this.isPressable) {
            this.isPressed = true;
            this.$emit("button-pressed");
        }
    }

    reset(): void {
        this.isPressed = false;
    }
}
